import { useEffect, useRef } from 'react';

import { useNetworkState } from '../use-network-state';

export function useOnReconnect(callback: () => void) {
    const { isOnline } = useNetworkState();

    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        if (isOnline) {
            callbackRef.current();
        }
    }, [isOnline]);
}
